import { ref, reactive, toRefs, nextTick } from 'vue'
import store from '@/store'
import { Message } from 'view-design'
import { initDownloadCenterTask } from '@/api/report.model'
import { PTOM_PLAN_DETAIL } from '@/views/download-center/data/const.js'

export function usePlanExport({ filterRef, buildQueryParams, tableColumns }) {
  const state = reactive({
    exportLoading: false
  })

  const onDownLoadAction = () => {
    const { baseParams } = buildQueryParams()
    const { beginTime, endTime } = baseParams

    const exportColumnOrderMap = {
      planName: '投放计划名称'
    }

    tableColumns.value.forEach((col) => {
      if (col.checked && !col.exclude_export) {
        exportColumnOrderMap[col.key] = col.title
      }
    })

    const conditionText = filterRef.value.getTransferedTaskQueryConditions({ beginTime, endTime }, PTOM_PLAN_DETAIL)
    const queryParams = Object.assign({}, baseParams, {
      conditionText,
      // limitConsumption: +filterState.limitConsumption,
      // allPlan: +filterState.allPlan,
      exportColumnOrderMap
    })

    state.exportLoading = true

    initDownloadCenterTask({
      pageType: PTOM_PLAN_DETAIL,
      queryCondition: queryParams
    })
      .then((data) => {
        state.exportLoading = false
        if (data.msg) {
          Message.success(data.msg)
          store.commit('setDownloadBadgeActive', 1)
        }
      })
      .catch(() => {
        state.exportLoading = false
      })
  }

  return {
    ...toRefs(state),
    onDownLoadAction
  }
}
